const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,

      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN,
          scopes: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [`${window.location.protocol}//${window.location.host}`],
          redirectSignOut: [`${window.location.protocol}//${window.location.host}`],
          responseType: 'code',
        },
      },
    },
  },
};

export default awsconfig;
